export const WORKER_WHATSAPP_LINK = 'https://wa.me/message/NLC6KWURYRKFB1';
export const RECRUITER_WHATSAPP_LINK = 'https://wa.me/message/LTB5KQ3TFWDLF1';
